export const MAX_CSV_FILE_SIZE: number = 32_000_000; // 32 MB
export const MAX_CLIENT_FOLDER_UPLOAD_SIZE: number = 32_000_000; // 32 MB
export const MAX_PROFILE_PIC_UPLOAD_SIZE: number = 10_000_000; // 10 MB
